var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "2c9b23fc4d3cd3a7edd522f1da4fef6f30ec0ccf"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "2c9b23fc4d3cd3a7edd522f1da4fef6f30ec0ccf"
};